import { FC } from 'react';
import CustomLazyPicker from 'src/view/components/Controls/Pickers/CustomLazyPicker/CustomLazyPicker';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { IPickerOption } from 'src/view/components/Controls/Pickers/Picker/types';
import logger from '~/services/logger';

interface IProps {
  menuGroupOption: IPickerOption | null;
  onSelect: (options: IPickerOption[]) => void;
}

const MenuGroupPicker: FC<IProps> = ({ menuGroupOption, onSelect }): JSX.Element => {
  return (
    <div className="d-flex flex-column">
      <p className="family-semibold text-size-18">{localeStore.t('menu_group')}</p>
      <CustomLazyPicker
        selectedOptions={menuGroupOption ? [menuGroupOption] : undefined}
        defaultOptions={[{ value: 0, label: localeStore.t('default') }]}
        maxNumberOfVisibleOptions={4}
        defaultPlaceholder="menu_group_name"
        className="working-hours-modal__mg-picker mt-2"
        onFetch={fetchMenuGroups}
        onSelect={onSelect}
      />
    </div>
  );
};

const fetchMenuGroups = async (page: number) => {
  try {
    return client.get('v3/menu_groups', {
      params: { page },
    });
  } catch (error: any) {
    logger.error({ error, place: 'MenuGroupPicker fetchMenuGroups' });
  }
};

export default MenuGroupPicker;
